import {
  ROLES_NAME,
  getCurrentUserRole,
  levelOptions,
  roleChange,
  roles,
  userCanEdit,
  userLevelCanEdit,
  validateEmail,
  validatePhone,
  weekOptions,
} from "modules/utilities/utility";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  Tabs,
  Tab,
  Tooltip,
  OverlayTrigger,
  InputGroup,
} from "react-bootstrap";
import {
  acivityLog,
  activateUsers,
  assignedCases,
  deactivateUsers,
  getUserFromSearch,
  updateUsers,
  useUserInfo,
  userRoles,
} from "./store";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import AuditLog from "./AuditLog";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Popconfirm } from "antd";
import SlotTimePicker from "./SlotTImePicker.jsx";
import secureLocalStorage from "react-secure-storage";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { REALLOCATE_USER_EMAIL_ACCESS } from "config";

const EditUsers = () => {
  const { roleData, getUserRoles } = userRoles();
  // const { userData, fetchUserData } = useUserInfo();
  const searchParams = new URLSearchParams(location.search);
  const { userid } = useParams();
  const [shifts, setShifts] = useState([]);
  const [shiftStartTime, setShiftStartTime] = useState(null);
  const [shiftEndTime, setShiftEndTime] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [deactivationModalShow, setDeactivationModalShow] = useState(false);
  const { userUpdate, isLoading } = updateUsers();
  const currentUser = getCurrentUserRole();
  const [hasFormErrors, setHasFormErrors] = useState(false);
  const { setToaster } = useToast();
  const { activityLogs } = acivityLog();
  const { searchResult } = getUserFromSearch();
  const { fetchassingnedCaseDetails, casesData } = assignedCases();
  let currentUserDeatils = [];
  const currentUserLevel = secureLocalStorage.getItem("level");
  const { deactivateCurrentUser, reallocateUserFunc } = deactivateUsers();
  const { activateCurrentUser } = activateUsers();
  const [slots, setSlots] = useState({});
  const { fetchUserData, userData } = useUserInfo();
  const clinicDoctor = ['clinic_doctor']
  useEffect(() => {
    fetchUserData(currentUser);
  }, [currentUser]);

  if (Array.isArray(userData)) {
    currentUserDeatils = userData.find((entry) => entry.user_id === userid);
  }

  if (!currentUserDeatils && searchResult) {
    currentUserDeatils = searchResult.find((item) => item.user_id === userid);
  }

  const [formData, setFormData] = useState({
    first_name: "",
    phone: "",
    email: "",
    alternate_email: "",
    level: 1,
    roles: "",
    description: "",
    breakDays: [],
    breakShifts: [],
    call_hippo: false,
    exotel_v2: false,
    is_consult_doctor: false,
    is_consult_doctor_active: false,
    is_intervention_doctor: false,
    can_do_female_presc: false,
    voitekk_id: null,
  });
  const [initialFormData, setInitialFormData] = useState({ ...formData });
  useEffect(() => {
    // Store the initial form data when it's first loaded
    setInitialFormData({ ...formData });
  }, [formData]);

  useEffect(() => {
    getUserRoles();
  }, []);

  useEffect(() => {
    if (currentUserDeatils) {
      const parseTimeStringToDate = (timeString) => {
        const [hours, minutes] = timeString.split(":");
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
        return date;
      };

      const mappedShifts =
        currentUserDeatils.user.meta.shifts &&
        currentUserDeatils.user.meta.shifts.map((shift, index) => ({
          startTime: parseTimeStringToDate(shift.startTime),
          endTime: parseTimeStringToDate(shift.endTime),
        }));

      setShifts(mappedShifts || []);

      setFormData((prevFormData) => ({
        ...prevFormData,
        first_name: currentUserDeatils?.user?.first_name || "",
        phone: currentUserDeatils?.user?.phone_number?.replace(/^\+91/, "") || "",
        email: currentUserDeatils?.user?.email || "",
        alternate_email: currentUserDeatils?.user?.alternate_email || "",
        level: currentUserDeatils?.user?.level,
        roles: currentUserDeatils?.role?.id,
        description: currentUserDeatils?.user?.meta?.bio?.description,
        breakDays: currentUserDeatils?.user?.meta?.breakWeekDays || [],
        call_hippo: currentUserDeatils?.user?.meta?.call_hippo || false,
        exotel_v2: currentUserDeatils?.user?.meta?.exotel_v2 || false,
        is_consult_doctor: currentUserDeatils?.user?.is_consult_doctor || false,
        is_consult_doctor_active:
          currentUserDeatils?.user?.is_consult_doctor_active || false,
        breakShifts: currentUserDeatils?.user?.meta?.shifts,
        is_intervention_doctor:
          currentUserDeatils?.user?.meta?.is_intervention_doctor,
        can_do_female_presc: currentUserDeatils?.user?.can_do_female_presc,
        voitekk_id: currentUserDeatils?.user?.voitekk_id,
      }));
    }
  }, [currentUserDeatils]);
  const [formErrors, setFormErrors] = useState({
    first_name: "",
    phone: "",
    email: "",
  });

  const validateField = (name, value) => {
    // Validation functions
    switch (name) {
      case "first_name":
        return value.trim() === "" ? "First name is required" : "";

      case "phone":
        return value.trim() === ""
          ? "Phone number is required"
          : !validatePhone(value)
          ? "Please valid Phone number with 10 digits"
          : "";

      case "email":
        return value.trim() === ""
          ? "Email is required, please use traya.health or trayahealth.com"
          : !validateEmail(value)
          ? "Please use traya.health or trayahealth.com"
          : "";

      default:
        return "";
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    // Validate the input field on change and update the corresponding error
    setFormErrors({
      ...formErrors,
      [name]: validateField(name, value),
    });
  };
  useEffect(() => {
    const hasErrors = Object.values(formErrors).some((error) => error !== "");
    setHasFormErrors(hasErrors);
  }, [formErrors]);
  const formatHourAndMinute = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const hour = date.getHours().toString().padStart(2, "0");
    const minute = date.getMinutes().toString().padStart(2, "0");
    return `${hour}:${minute}`;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    for (const fieldName in formData) {
      if (formData.hasOwnProperty(fieldName)) {
        errors[fieldName] = validateField(fieldName, formData[fieldName]);
      }
    }
    setFormErrors(errors);

    // Check if there are any errors
    if (Object.values(errors).every((error) => error === "")) {
      const _user = {
        first_name: formData.first_name?.trim(),
        alternate_email: formData.alternate_email.trim(),
        email: formData?.email?.trim(),
        phone_number: "+91" + formData?.phone?.trim(),
        level: parseInt(formData.level),
        meta: {
          ...currentUserDeatils.meta,
          bio: {
            description: formData?.description,
          },
          breakWeekDays: formData?.breakDays,
          call_hippo: formData.call_hippo,
          exotel_v2: formData.exotel_v2,
          is_intervention_doctor: formData?.is_intervention_doctor,
          shifts: shifts.map((entry) => ({
            startTime: formatHourAndMinute(entry.startTime),
            endTime: formatHourAndMinute(entry.endTime),
          })),
          slots:
            !isEmpty(slots) ? slots : currentUserDeatils?.user.meta?.slots,
        },
        is_consult_doctor: formData.is_consult_doctor,
        is_consult_doctor_active: formData.is_consult_doctor_active,
        role:
          formData.roles !== "" ? formData.roles : currentUserDeatils.roleId,
        can_do_female_presc: formData.can_do_female_presc,
        voitekk_id: parseInt(formData.voitekk_id),
      };
      userUpdate(
        currentUserDeatils.user_id,
        { user: _user },
        setToaster,
        fetchUserData,
        currentUser
      );
      activityLogs(currentUserDeatils.user_id, {
        authorName: secureLocalStorage.getItem("first_name"),
        original: currentUserDeatils,
        modified: _user,
      });
    }
  };
  const handleBreakDaysChange = (selectedDay) => {
    const updatedBreakDays = formData?.breakDays.includes(selectedDay)
      ? formData?.breakDays.filter((day) => day !== selectedDay) // Remove the day if it's already in the array
      : [...formData?.breakDays, selectedDay]; // Add the day if it's not in the array
    setFormData({ ...formData, breakDays: updatedBreakDays });
  };

  const handleShiftStartTimeChange = (date, index) => {
    const updatedShifts = [...shifts];
    updatedShifts[index].startTime = date;
    setShifts(updatedShifts);
  };

  const handleShiftEndTimeChange = (date, index) => {
    const updatedShifts = [...shifts];
    updatedShifts[index].endTime = date;
    setShifts(updatedShifts);
  };

  const handleRemoveShift = (index) => {
    const updatedShifts = [...shifts];
    updatedShifts.splice(index, 1);
    setShifts(updatedShifts);
  };

  const handleAddShift = () => {
    if (shiftStartTime && shiftEndTime) {
      const startTimeMinus5Hours30Minutes = moment(shiftStartTime)
        .subtract(5, "hours")
        .subtract(30, "minutes")
        .toDate();
      const endTimeMinus5Hours30Minutes = moment(shiftEndTime)
        .subtract(5, "hours")
        .subtract(30, "minutes")
        .toDate();
      setShifts([
        ...shifts,
        {
          startTime: startTimeMinus5Hours30Minutes,
          endTime: endTimeMinus5Hours30Minutes,
        },
      ]);
      setShiftStartTime(null);
      setShiftEndTime(null);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      breakShifts: shifts,
    }));
  };
  const handleConsultDoctor = (event) => {
    const { name, checked } = event.target;
    if (name === "consultDoctor") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        is_consult_doctor: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        is_consult_doctor_active: checked,
      }));
    }
  };
  const handleCallHippoChange = (event) => {
    const { name, checked } = event.target;
    if (name === "exotel_v2") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        exotel_v2: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        call_hippo: checked,
      }));
    }
  };

  const handleInterventionDoctor = (event) => {
    const { name, checked } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      is_intervention_doctor: checked,
    }));
  };

  const goBack = () => {
    window.history.back();
  };
  useEffect(() => {
    // Check if currentUserDeatils is defined before making the API call
    if (currentUserDeatils && currentUserDeatils.user_id) {
      fetchassingnedCaseDetails(currentUserDeatils.user_id);
    }
  }, [currentUserDeatils]);

  const handleDeactivateModal = async () => {
    setDeactivationModalShow(true);
  };

  const handleDeactivateButton = async () => {
    setDeactivationModalShow(false);
    deactivateCurrentUser(
      currentUserDeatils.user_id,
      setToaster,
      fetchUserData,
      currentUser
    );
  };
  const handleToggleActivation = () => {
    if (!validatePhone(formData.phone)) {
      setToaster("Edit User", "Invalid phone number", "danger");
      return; // Don't proceed with activation
    }

    activateCurrentUser(
      currentUserDeatils.user_id,
      setToaster,
      fetchUserData,
      currentUser
    );
  };
  const handleFemalePrescCahnges = (selection) => {
    const checked = selection.target.checked;
    setFormData((prevFormData) => ({
      ...prevFormData,
      can_do_female_presc: checked,
    }));
  };

  const handleVoitekkChange = (event) => {
    const checked = event.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      voitekk_id: checked,
    }));
  };

  const reallocateButtonLogic = () => {
    const isLevelValid = [1, 3].includes(formData?.level);
    let roleUser;
    let isRoleValid = false;
    if(formData?.roles){
      roleUser = roles[formData?.roles];
      isRoleValid = roleUser.includes(ROLES_NAME.MEDICAL_REP);
    }

    return isLevelValid && isRoleValid;
  };

  const handleReallocateSubmit = async () => {
    reallocateUserFunc(
      currentUserDeatils.user_id,
      setToaster,
    );
  }

  const isSuperAdmin = [ROLES_NAME.SUPER_ADMIN].includes(currentUser);
  const hasEmailAccess = REALLOCATE_USER_EMAIL_ACCESS.includes(
    secureLocalStorage.getItem("email")
  );

  return (
    <>
      <Button className="me-3" variant="primary" onClick={goBack}>
        Back
      </Button>
      <Tabs defaultActiveKey="userEdit" id="user-edit-tab">
        <Tab
          eventKey="userEdit"
          title="Edit User"
          // className="border-bottom border-x p-3"
        >
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <div className="fs-2 text-black">Edit User</div>
                {currentUserDeatils?.user.deactivated ? (
                  <OverlayTrigger
                    key={top}
                    placement="top"
                    overlay={
                      <Tooltip
                        style={{ position: "fixed", fontSize: "12px" }}
                        id={"tooltip-" + "top"}
                      >
                        Please save the user profile with the right phone
                        number.
                      </Tooltip>
                    }
                  >
                    <button
                      className="btn btn-success"
                      // disabled={!isPhoneValid}
                      onClick={handleToggleActivation}
                    >
                      Activate
                    </button>
                  </OverlayTrigger>
                ) : (
                  <div className="gap-3">
                    {(isSuperAdmin || hasEmailAccess) ? (
                      <span> {/* Wrap button with a span to allow tooltip on hover */} 
                          <button
                              className="btn btn-primary"
                              disabled={!reallocateButtonLogic()}
                              onClick={handleReallocateSubmit}
                          >
                              Reallocate
                          </button>
                      </span>
                ) : null}
                    <button
                      className="btn btn-danger"
                      onClick={handleDeactivateModal}
                    >
                      Deactivate
                    </button>
                  </div>
                )}
                <Modal
                  show={deactivationModalShow}
                  onHide={() => setDeactivationModalShow(false)}
                  size="sm"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Assignment Details
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>Active Engagement Cases:</td>
                          <td>{casesData.activeEngagementCaseCount}</td>
                        </tr>
                        <tr>
                          <td>Open Order Cases:</td>
                          <td>{casesData.openOrderCasesCount}</td>
                        </tr>
                        <tr>
                          <td>Escalated Cases:</td>
                          <td>{casesData.escalatedCasesCount}</td>
                        </tr>
                        <tr>
                          <td>Slot Cases:</td>
                          <td>{casesData.slotCasesCount}</td>
                        </tr>
                        <tr>
                          <td>Temporary Assigned Cases:</td>
                          <td>{casesData.temporaryAssignedCases}</td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="text-danger">
                      Deactivating the user will reassign the currently assigned
                      cases.
                    </p>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      className="btn btn-danger"
                      onClick={() => handleDeactivateButton()}
                    >
                      Deactivate
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>

              {currentUser && (
                <>
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3 d-flex">
                      <Form.Group as={Col} md="4">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleInputChange}
                          required
                        />
                        <span className="text-danger">
                          {formErrors.first_name}
                        </span>
                      </Form.Group>

                      <Form.Group as={Col} md="4">
                        <Form.Label>Phone Number</Form.Label>
                        <InputGroup className="mb-3">
                          <InputGroup.Text id="basic-addon1">
                            +91
                          </InputGroup.Text>
                          <Form.Control
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                          />
                        </InputGroup>
                        <span className="text-danger">{formErrors.phone}</span>
                      </Form.Group>

                      <Form.Group as={Col} md="4">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                        <span className="text-danger">{formErrors.email}</span>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3 d-flex">
                      {/* <Form.Group as={Col} md="4">
                        <Form.Label>Alternate Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="alternate_email"
                          value={formData.alternate_email}
                          onChange={handleInputChange}
                        />
                      </Form.Group> */}

                      <Form.Group as={Col} md="4">
                        <Form.Label>Level</Form.Label>
                        <OverlayTrigger
                          key={top}
                          placement="top"
                          overlay={
                            <Tooltip
                              style={{ position: "fixed", fontSize: "12px" }}
                              id={"tooltip-" + "top"}
                            >
                              Changing the user level may affect their
                              permissions access and the assigned cases will be
                              reassigned.
                            </Tooltip>
                          }
                        >
                          <Form.Control
                            as="select"
                            name="level"
                            value={formData.level}
                            onChange={handleInputChange}
                            disabled={
                              !userCanEdit.includes(currentUser) ||
                              (!userCanEdit.includes(currentUser) &&
                                !userLevelCanEdit.includes(currentUserLevel))
                            }
                          >
                            {levelOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Form.Control>
                        </OverlayTrigger>
                      </Form.Group>

                      <Form.Group as={Col} md="4">
                        <Form.Label>Role</Form.Label>
                        <OverlayTrigger
                          key={top}
                          placement="top"
                          disabled={
                            !userCanEdit.includes(currentUser) ||
                            (!userCanEdit.includes(currentUser) &&
                              !userLevelCanEdit.includes(currentUserLevel))
                          }
                          overlay={
                            <Tooltip
                              style={{ position: "fixed", fontSize: "12px" }}
                              id={"tooltip-" + "top"}
                            >
                              Changing the user role may affect their
                              permissions access and the assigned cases will be
                              reassigned.
                            </Tooltip>
                          }
                        >
                          {roleChange.includes(currentUserLevel) ? (
                            <Form.Control
                              as="select"
                              name="roles"
                              value={formData.roles}
                              onChange={handleInputChange}
                              disabled
                            >
                              {roleData?.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </Form.Control>
                          ) : (
                            <Form.Select
                              required
                              value={formData.roles}
                              onChange={(event) => {
                                const selectedValue = event.target.value;
                                if(![ROLES_NAME.SUPER_ADMIN].includes(currentUser) && [ROLES_NAME.SUPER_ADMIN].includes(roles[selectedValue])){
                                  toast.warning(`You don't have access to changes role to super_admin`);
                                  return null;
                                }
                                return setFormData({
                                  ...formData,
                                  roles: selectedValue,
                                });
                              }}
                            >
                              {roleData?.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </Form.Select>
                          )}
                        </OverlayTrigger>
                      </Form.Group>
                      <Form.Group as={Col} md="4">
                        <Form.Label>Voitekk Id</Form.Label>
                        <Form.Control
                          type="number"
                          name="voitekk_id"
                          value={formData.voitekk_id}
                          onChange={handleVoitekkChange}
                        />
                      </Form.Group>
                    </Row>
                    <Row className="mb-3 d-flex">
                      {/* <Form.Group as={Col} md="4" controlId="description">
                        <Form.Label>Description </Form.Label>
                        <Form.Control
                          as="textarea"
                          type="text"
                          placeholder="Description"
                          defaultValue={formData.description}
                          onChange={(event) =>
                            setFormData({
                              ...formData,
                              description: event.target.value,
                            })
                          }
                        />
                      </Form.Group> */}
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="BreakDays"
                        className="pt-3 d-flex  flex-column justify-content-center"
                      >
                        <Form.Label>Break Days</Form.Label>
                        <OverlayTrigger
                          key={top}
                          placement="top"
                          overlay={
                            <Tooltip
                              style={{ position: "fixed", fontSize: "12px" }}
                              id={"tooltip-" + "top"}
                            >
                              Changing the break week day may affect the
                              availability for case assignment
                            </Tooltip>
                          }
                        >
                          <div>
                            {weekOptions.map((weekday) => (
                              <Form.Check key={weekday.value} inline>
                                <Form.Check.Input
                                  type="checkbox"
                                  value={weekday.value}
                                  id={weekday.label}
                                  checked={formData.breakDays.includes(
                                    weekday.value
                                  )}
                                  onChange={() =>
                                    handleBreakDaysChange(weekday.value)
                                  }
                                />
                                <Form.Check.Label htmlFor={weekday.value}>
                                  {weekday.label}
                                </Form.Check.Label>
                              </Form.Check>
                            ))}
                          </div>
                        </OverlayTrigger>
                      </Form.Group>
                      <div className="mt-3">
                        <div className="d-flex gap-3">
                          <Button
                            variant="primary"
                            onClick={() => setModalShow(true)}
                          >
                            Add Shift
                          </Button>
                          {(formData?.is_consult_doctor_active ||
                            formData?.is_consult_doctor ||
                            formData?.is_intervention_doctor || 
                            clinicDoctor.includes(roles[formData.roles])) && (
                            <SlotTimePicker
                              setSlots={setSlots}
                              slot={currentUserDeatils?.user.meta?.slots}
                            />
                          )}
                        </div>
                        <Modal
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          size="lg"
                          aria-labelledby="contained-modal-title-vcenter"
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                              Break Timings
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {shifts.map((eachShift, index) => {
                              const startTimeMinus5Hours30Minutes = moment(
                                eachShift.startTime
                              )
                                .add(5, "hours")
                                .add(30, "minutes")
                                .toDate();

                              const endTimeMinus5Hours30Minutes = moment(
                                eachShift.endTime
                              )
                                .add(5, "hours")
                                .add(30, "minutes")
                                .toDate();
                              return (
                                <div
                                  key={index}
                                  className="d-flex w-75 border rounded p-0"
                                >
                                  <div className="flex-1 p-0 w-50">
                                    <DatePicker
                                      selected={startTimeMinus5Hours30Minutes}
                                      onChange={(date) =>
                                        handleShiftStartTimeChange(date, index)
                                      }
                                      showTimeSelect
                                      showTimeSelectOnly
                                      timeIntervals={15}
                                      dateFormat="h:mm aa"
                                      placeholderText="Select Start Time"
                                      className="form-control border-0 m-0"
                                      readOnly
                                    />
                                  </div>
                                  <div className="flex-1">
                                    <DatePicker
                                      selected={endTimeMinus5Hours30Minutes}
                                      onChange={(date) =>
                                        handleShiftEndTimeChange(date, index)
                                      }
                                      showTimeSelect
                                      showTimeSelectOnly
                                      timeIntervals={15}
                                      dateFormat="h:mm aa"
                                      placeholderText="Select End Time"
                                      className="form-control border-0 m-0"
                                      readOnly
                                    />
                                  </div>
                                  <button
                                    onClick={() => handleRemoveShift(index)}
                                    className="btn btn-danger ml-2"
                                  >
                                    Remove
                                  </button>
                                </div>
                              );
                            })}
                            <div className="d-flex w-75 border rounded p-0">
                              <div className="flex-1 p-0 w-50">
                                <DatePicker
                                  selected={shiftStartTime}
                                  onChange={(date) => setShiftStartTime(date)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  placeholderText="Select Start Time"
                                  className="form-control border-0 m-0"
                                />
                              </div>
                              <div className="flex-1">
                                <DatePicker
                                  selected={shiftEndTime}
                                  onChange={(date) => setShiftEndTime(date)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={15}
                                  dateFormat="h:mm aa"
                                  placeholderText="Select End Time"
                                  className="form-control border-0 m-0"
                                />
                              </div>
                              <button
                                onClick={handleAddShift}
                                className="btn btn-primary"
                              >
                                Add Shift
                              </button>
                            </div>
                          </Modal.Body>

                          <Modal.Footer>
                            <button
                              onClick={() => setShifts([])}
                              className="btn btn-warning mt-2"
                            >
                              Clear All
                            </button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    </Row>
                    <div className="d-flex justify-content-between ms-2 mb-5">
                      <div className="flex-1">
                        <div className="fs-2 text-black">Consult Doctor</div>
                        <div className="d-flex align-items-center">
                          <div className="me-2">
                            <Form.Check
                              type="checkbox"
                              id="consult-doctor"
                              label="Consult Doctor"
                              name="consultDoctor"
                              checked={formData.is_consult_doctor}
                              onChange={handleConsultDoctor}
                            />
                          </div>
                          <div className="">
                            <Form.Check
                              type="checkbox"
                              id="checkedCheckbox"
                              label="Consult Doctor Active"
                              name="consultDoctorActive"
                              checked={formData.is_consult_doctor_active}
                              onChange={handleConsultDoctor}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 ps-3">
                        <div className="fs-2 text-black">
                          Intervention Doctor
                        </div>
                        <div className="">
                          <Form.Check
                            type="checkbox"
                            id="interventionCheckbox"
                            label="Intervention Doctor Active"
                            name="is_intervention_doctor"
                            checked={formData.is_intervention_doctor}
                            onChange={handleInterventionDoctor}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-1 ps-3">
                        <div className="fs-2 text-black">External Configs</div>
                        <div className="d-flex">
                          <div className="me-2 ">
                            <Form.Check
                              type="checkbox"
                              id="call-hippo-dialer"
                              label="Call Hippo Dialer"
                              name="callHippo"
                              checked={formData.call_hippo}
                              onChange={handleCallHippoChange}
                            />
                          </div>
                          <div className="">
                            <Form.Check
                              type="checkbox"
                              id="call-exotel-dialer"
                              label="ExotelV2 Dialer"
                              name="exotel_v2"
                              checked={formData.exotel_v2}
                              onChange={handleCallHippoChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-1 ps-3">
                        <div className="fs-2 text-black">
                          Can do female prescirption
                        </div>
                        <div className="d-flex">
                          <div className="me-2 ">
                            <Form.Check
                              type="checkbox"
                              id="can-do-female-presc"
                              label="Can do female presc"
                              name="femalePresc"
                              checked={formData.can_do_female_presc}
                              onChange={handleFemalePrescCahnges}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-row  justify-content-center">
                      <Popconfirm
                        title="Are you sure you want to proceed with the edit in user details?"
                        onConfirm={handleSubmit}
                        okText="Yes"
                        cancelText="No"
                        okType=""
                      >
                        <Button
                          className="w-25 "
                          disabled={hasFormErrors || isLoading}
                          style={{ height: "3rem" }}
                        >
                          Save Edits
                        </Button>
                      </Popconfirm>
                    </div>
                  </Form>
                </>
              )}
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="auditLog" title="Audit Log">
          {currentUserDeatils && (
            <AuditLog userid={currentUserDeatils.user_id} />
          )}
        </Tab>
      </Tabs>
    </>
  );
};

export default EditUsers;
